const sourceOfFunds = ["Employment", "Inheritance", "Third party", "Grant/Loan"];
export default sourceOfFunds;